import PageTypesSettings from 'features/page-types-settings/PageTypesSettings';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function SiteConfigPageTypes() {
  useRequireRoles(ROLE_TYPE.ADMIN);

  return (
    <SiteConfigPage title="Page Types">
      <PageTypesSettings />
    </SiteConfigPage>
  );
}

export default SiteConfigPageTypes;
